module.exports = __webpack_public_path__ + "img/no-data-search-dark.ffe4076.svg";